module.exports = __webpack_public_path__ + "assets/img/img88.95f995b7.png";